import React from 'react';
import { formatRupiah } from '../data/financialData';
import SmartTooltip from './SmartTooltip';
import type { InsightItem } from '../utils/smartInsightsEngine';

interface KPICardProps {
  title: string;
  value: number;
  change?: number;
  changeLabel?: string;
  type: 'revenue' | 'expenses' | 'profit' | 'cashflow';
  icon: string;
  animationDelay?: number;
  onClick?: () => void;
  tooltip?: string;
  smartInsights?: InsightItem[];
}

const KPICard: React.FC<KPICardProps> = ({ title, value, change, changeLabel, type, icon, animationDelay = 0, onClick, tooltip, smartInsights }) => {
  const isPositive = change !== undefined ? change >= 0 : value >= 0;
  const clickable = !!onClick;

  const card = (
    <div
      className={`kpi-card ${type} animate-in animate-in-delay-${animationDelay}${clickable ? ' kpi-card-clickable' : ''}`}
      id={`kpi-${type}`}
      onClick={onClick}
      title={tooltip}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter') onClick?.(); } : undefined}
    >
      <div className="kpi-card-header">
        <span className="kpi-card-title">{title}</span>
        <div className="kpi-card-icon">{icon}</div>
      </div>
      <div className="kpi-card-value">{formatRupiah(value)}</div>
      {change !== undefined && (
        <span className={`kpi-card-change ${isPositive ? 'positive' : 'negative'}`}>
          {isPositive ? '▲' : '▼'} {Math.abs(change).toFixed(1)}% {changeLabel || 'vs bulan lalu'}
        </span>
      )}
      {clickable && (
        <div className="kpi-card-drill-hint">
          <span>Klik untuk detail →</span>
        </div>
      )}
    </div>
  );

  // Wrap with SmartTooltip if insights are available
  if (smartInsights && smartInsights.length > 0) {
    return (
      <SmartTooltip insights={smartInsights} title={title}>
        {card}
      </SmartTooltip>
    );
  }

  return card;
};

export default KPICard;
